import { hash } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { task, timeout } from 'ember-concurrency';
import perform from 'ember-concurrency/helpers/perform';
import { t } from 'ember-intl';
import PowerSelect from 'ember-power-select/components/power-select';
import { isEmpty, not } from 'ember-truth-helpers';

import { query } from 'umg-ember-backend/data/builders/umg-rest';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from '../select.module.css';

const bem = getBem(styles);

export default class ApplicationHeaderSelectUser extends Component {
  // Services
  @service currentUser;
  @service filter;
  @service permission;
  @service store;

  // Functions
  setUser = async (user) => {
    this.filter.globalUser = await user;
  };

  searchUser = task({ restartable: true }, async (term) => {
    await timeout(1000);

    const { content } = await this.store.request(
      query('user', {
        'search[value]': term,
        'search[mode]': 'contains',
        'limit': 50,
      }),
    );

    return content.data ?? [];
  });

  // Template
  <template>
    {{#if this.currentUser.isAdmin}}
      <PowerSelect
        @allowClear={{true}}
        @loadingMessage={{t 'application.header.select_user.loading_message'}}
        @onChange={{this.setUser}}
        @placeholder={{t 'application.header.select_user.placeholder'}}
        @searchMessage={{null}}
        @searchPlaceholder={{t
          'application.header.select_user.search_placeholder'
        }}
        @renderInPlace={{true}}
        @search={{perform this.searchUser}}
        @searchEnabled={{true}}
        @selected={{this.filter.globalUser}}
        @triggerClass={{bem
          'trigger'
          (hash is-selected=(not (isEmpty this.selectedArtist)))
        }}
        @dropdownClass={{bem
          'dropdown'
          (hash is-selected=(not (isEmpty this.selectedArtist)))
        }}
        as |option|
      >
        {{option.displayLabel}}
      </PowerSelect>
    {{/if}}
  </template>
}
